import { TreeDataNode } from "antd";

export const dataTypeTreeData: TreeDataNode[] = [
  {
    title: "Common Shares",
    key: "Common Shares",
    children: [
      { title: "Class A", key: "Common Shares_Class A", isLeaf: true },
      { title: "Class B", key: "Common Shares_Class B", isLeaf: true },
      { title: "Class C", key: "Common Shares_Class C", isLeaf: true },
      { title: "Other", key: "Common Shares_Other", isLeaf: true },
    ],
  },
  {
    title: "Restricted Share Instruments",
    key: "Restricted Share Instruments",
    children: [
      { title: "RSUs", key: "Restricted Share Instruments_RSUs", isLeaf: true },
      { title: "PSUs", key: "Restricted Share Instruments_PSUs", isLeaf: true },
      { title: "Other", key: "Restricted Share Instruments_Other", isLeaf: true },
    ],
  },
  {
    title: "Options",
    key: "Options",
    children: [
      {
        title: "Number of Shares Outstanding",
        key: "Options_Number of Shares Outstanding",
        children: [
          {
            title: "Total Outstanding",
            key: "Options_Number of Shares Outstanding_Total Outstanding",
            children: [
              { title: "Tranche 1", key: "Options_Number of Shares Outstanding_Total Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options_Number of Shares Outstanding_Total Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options_Number of Shares Outstanding_Total Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options_Number of Shares Outstanding_Total Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options_Number of Shares Outstanding_Total Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Exercisable Outstanding",
            key: "Options_Number of Shares Outstanding_Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Options_Number of Shares Outstanding_Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options_Number of Shares Outstanding_Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options_Number of Shares Outstanding_Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options_Number of Shares Outstanding_Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options_Number of Shares Outstanding_Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Non-Exercisable Outstanding",
            key: "Options_Number of Shares Outstanding_Non-Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Options_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
        ],
      },
      {
        title: "Weighted Average Exercise Price",
        key: "Options_Weighted Average Exercise Price",
        children: [
          {
            title: "Total Outstanding",
            key: "Options_Weighted Average Exercise Price_Total Outstanding",
            children: [
              { title: "Tranche 1", key: "Options_Weighted Average Exercise Price_Total Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options_Weighted Average Exercise Price_Total Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options_Weighted Average Exercise Price_Total Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options_Weighted Average Exercise Price_Total Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options_Weighted Average Exercise Price_Total Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Exercisable Outstanding",
            key: "Options_Weighted Average Exercise Price_Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Options_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Non-Exercisable Outstanding",
            key: "Options_Weighted Average Exercise Price_Non-Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Options_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Warrants",
    key: "Warrants",
    children: [
      {
        title: "Number of Shares Outstanding",
        key: "Warrants_Number of Shares Outstanding",
        children: [
          {
            title: "Total Outstanding",
            key: "Warrants_Number of Shares Outstanding_Total Outstanding",
            children: [
              { title: "Tranche 1", key: "Warrants_Number of Shares Outstanding_Total Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Warrants_Number of Shares Outstanding_Total Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Warrants_Number of Shares Outstanding_Total Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Warrants_Number of Shares Outstanding_Total Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Warrants_Number of Shares Outstanding_Total Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Exercisable Outstanding",
            key: "Warrants_Number of Shares Outstanding_Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Warrants_Number of Shares Outstanding_Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Warrants_Number of Shares Outstanding_Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Warrants_Number of Shares Outstanding_Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Warrants_Number of Shares Outstanding_Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Warrants_Number of Shares Outstanding_Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Non-Exercisable Outstanding",
            key: "Warrants_Number of Shares Outstanding_Non-Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Warrants_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Warrants_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Warrants_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Warrants_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Warrants_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
        ],
      },
      {
        title: "Weighted Average Exercise Price",
        key: "Warrants_Weighted Average Exercise Price",
        children: [
          {
            title: "Total Outstanding",
            key: "Warrants_Weighted Average Exercise Price_Total Outstanding",
            children: [
              { title: "Tranche 1", key: "Warrants_Weighted Average Exercise Price_Total Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Warrants_Weighted Average Exercise Price_Total Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Warrants_Weighted Average Exercise Price_Total Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Warrants_Weighted Average Exercise Price_Total Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Warrants_Weighted Average Exercise Price_Total Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Exercisable Outstanding",
            key: "Warrants_Weighted Average Exercise Price_Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Warrants_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Warrants_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Warrants_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Warrants_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Warrants_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Non-Exercisable Outstanding",
            key: "Warrants_Weighted Average Exercise Price_Non-Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Warrants_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Warrants_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Warrants_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Warrants_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Warrants_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
        ],
      },
    ],
  },
  {
    title: "Options & Warrants (Other)",
    key: "Options & Warrants (Other)",
    children: [
      {
        title: "Number of Shares Outstanding",
        key: "Options & Warrants (Other)_Number of Shares Outstanding",
        children: [
          {
            title: "Total Outstanding",
            key: "Options & Warrants (Other)_Number of Shares Outstanding_Total Outstanding",
            children: [
              { title: "Tranche 1", key: "Options & Warrants (Other)_Number of Shares Outstanding_Total Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options & Warrants (Other)_Number of Shares Outstanding_Total Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options & Warrants (Other)_Number of Shares Outstanding_Total Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options & Warrants (Other)_Number of Shares Outstanding_Total Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options & Warrants (Other)_Number of Shares Outstanding_Total Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Exercisable Outstanding",
            key: "Options & Warrants (Other)_Number of Shares Outstanding_Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Options & Warrants (Other)_Number of Shares Outstanding_Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options & Warrants (Other)_Number of Shares Outstanding_Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options & Warrants (Other)_Number of Shares Outstanding_Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options & Warrants (Other)_Number of Shares Outstanding_Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options & Warrants (Other)_Number of Shares Outstanding_Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Non-Exercisable Outstanding",
            key: "Options & Warrants (Other)_Number of Shares Outstanding_Non-Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Options & Warrants (Other)_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options & Warrants (Other)_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options & Warrants (Other)_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options & Warrants (Other)_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options & Warrants (Other)_Number of Shares Outstanding_Non-Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
        ],
      },
      {
        title: "Weighted Average Exercise Price",
        key: "Options & Warrants (Other)_Weighted Average Exercise Price",
        children: [
          {
            title: "Total Outstanding",
            key: "Options & Warrants (Other)_Weighted Average Exercise Price_Total Outstanding",
            children: [
              { title: "Tranche 1", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Total Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Total Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Total Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Total Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Total Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Exercisable Outstanding",
            key: "Options & Warrants (Other)_Weighted Average Exercise Price_Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
          {
            title: "Non-Exercisable Outstanding",
            key: "Options & Warrants (Other)_Weighted Average Exercise Price_Non-Exercisable Outstanding",
            children: [
              { title: "Tranche 1", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 1", isLeaf: true },
              { title: "Tranche 2", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 2", isLeaf: true },
              { title: "Tranche 3", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 3", isLeaf: true },
              { title: "Tranche 4", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 4", isLeaf: true },
              { title: "Tranche 5", key: "Options & Warrants (Other)_Weighted Average Exercise Price_Non-Exercisable Outstanding_Tranche 5", isLeaf: true },
            ],
          },
        ],
      },
    ],
  },
];

